import React, { useState, useMemo, useEffect } from 'react';
import { MaterialReactTable, useMaterialReactTable } from 'material-react-table';
import { Typography, Backdrop, TextField, CircularProgress, Button, Box } from "@mui/material";
import {useCheckRole } from '_utils/role-access';

const FirmList=({data,handleChange, setIsSaveButtonEnabled})=>
{
    const hasUpdateSummaryAdjustmentsByFirmMarketerGroupsAccess = useCheckRole(4,"UpdateSummaryAdjustmentsByFirmMarketerGroups")
    const handleInputChange = (row, value) => {
        setIsSaveButtonEnabled(true);
        handleChange(row, value);
    };

    const columns = useMemo(
        () => [
            {
                accessorKey: "AllocationGroup",
                header: "Firm GROUP Name",
            },
            {
                accessorKey: "PreviousBalanceFirm",
                header: "Monthly Group Imbalance",
                Cell: ({ cell }) => (
                    <Typography sx={{ fontWeight: "500", color: "#4A4A4A", textAlign: "right",paddingRight:5 }}>
                        {typeof cell.getValue() === 'number' ? cell.getValue().toLocaleString() : cell.getValue()}
                    </Typography>
                )
            },
            {
                accessorKey: "ImbalanceAdjustedVolume",
                header: "Monthly Imbalance Adjustment",
                Cell: ({cell, row }) => (
                    <Box>
                        <TextField
                            variant="standard"
                            value={typeof cell.getValue() === 'number' ? cell.getValue().toLocaleString() : cell.getValue()}
                            onChange={(e) =>  handleInputChange(row, e.target.value)}
                            InputProps={{
                                disableUnderline: true,
                            }}
                            disabled={!hasUpdateSummaryAdjustmentsByFirmMarketerGroupsAccess}
                        />
                    </Box>
                ),
            },
            {
                accessorKey: "MonthEndImbalanceFirm",
                header: "Ending Monthly Inventory Balance",
                Cell: ({ cell }) => (
                    <Typography sx={{ fontWeight: "500", color: "#4A4A4A", textAlign: "right",paddingRight:5 }}>
                        {typeof cell.getValue() === 'number' ? cell.getValue().toLocaleString() : cell.getValue()}
                    </Typography>
                )
            },
        ],
        [data]
    );

    const table = useMaterialReactTable({
        columns,
        data,
        enableHiding: false,
        enablePagination: false,
        enableBottomToolbar: false, // Hide bottom toolbar
        enableColumnFilters: false,
        enableSorting: false,
        enableColumnActions: false,
        enableGlobalFilter: false,
        enableDensityToggle: false,
        enableColumnHiding: false,
        positionToolbarAlertBanner: "none",     // Hide the density toggle
        enableColumnVisibility: false,   // Hide the column visibility toggle
        enableFullScreenToggle: false,   // Hide the full-screen toggle
        initialState: {
            columnOrder: [
             "AllocationGroup",
             "PreviousBalanceFirm",
             "ImbalanceAdjustedVolume",
             "MonthEndImbalanceFirm"
            ]},
        muiTableBodyCellProps: {
            sx: { borderBottom: "none" }, // Remove borders
        },
        muiTableHeadCellProps: {
            sx: {
                fontWeight: "bold",
                color: "#0B254B",
                textAlign: "left",
            },
        },
        muiTableContainerProps: {
            sx: {
              maxHeight: '400px',
            },
          },
        renderToolbarInternalActions: () => null,
    });

    return (
        <div>
             {/* Table */}
             <MaterialReactTable table={table} />
        </div>
    );
}

export default FirmList;